import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { TicketLockView } from 'src/app/services/ticket-edit-lock.session';

/**
 * Avviso mostrato sopra un form di modifica quando il record è in uso da un altro utente.
 * Non fa nulla da solo: "Riprova" e "Forza sblocco" sono eventi per la pagina.
 */
@Component({
  selector: 'app-edit-lock-banner',
  templateUrl: './edit-lock-banner.component.html',
  styleUrls: ['./edit-lock-banner.component.scss'],
})
export class EditLockBannerComponent {
  @Input({ required: true }) view!: TicketLockView;
  @Output() retry = new EventEmitter<void>();
  @Output() force = new EventEmitter<void>();

  constructor(private confirmationService: ConfirmationService) {}

  get visible(): boolean {
    return this.view.status === 'blocked' || this.view.status === 'lost';
  }

  /** Chi lo tiene: "da te in un'altra scheda" se è lo stesso utente. */
  get holder(): string {
    return this.view.sameUser ? 'aperto da te in un’altra scheda' : (this.view.lockedByName ?? '');
  }

  confirmForce() {
    this.confirmationService.confirm({
      header: 'Forza sblocco',
      icon: 'pi pi-exclamation-triangle',
      message: `Il ticket è in uso${
        this.view.lockedByName && !this.view.sameUser ? ` da ${this.view.lockedByName}` : ''
      }. Forzando lo sblocco le sue modifiche non ancora salvate andranno perse. Continuare?`,
      acceptLabel: 'Forza sblocco',
      rejectLabel: 'Annulla',
      accept: () => this.force.emit(),
    });
  }
}
